import {imageBaseUrl} from "config";

export const partnerOfferings = {
    Fino: {
        name: "Fino Payments Bank Limited",
        companyName: "Fino",
        offers: [
            "Credit upto Rs. 2 lacs",
            "2.5% flat interest per month",
            "Anytime withdrawal",
            "1 day repayment",
            "Money in Fino Account",
        ],
        logo: `${imageBaseUrl}/img/FinoPaymentsBankNewLogoIndingo.jpg`,
        message: "You have successfully submitted your consent to avail credit line service of Ekagrata Finance via MyShubhLife. MyShubhLife team will reach you shortly.",
    },
    scadvantageclub : {
        name: "Advantage Club Private Limited",
        companyName: "Advantage Club",
        offers: [
            "Credit up to Rs. 2 lacs",
            "2.5% flat interest per month",
            "1-day disbursement",
            "Money into your bank account",
            "No physical documentation and verification",
        ],
        logo: `${imageBaseUrl}/img/logo/advantageClubLogo.png`,
    },
    SCEASYPAY: {
        name: "Easy Pay Private Limited",
        headerLogo: `${imageBaseUrl}/img/logo/easypay-logo.png`,
        colors: {
            green: '#35bb8d',
            blue: '#624fa1',
            white: '#ffffff',
        },
        optionCardIcon: `${imageBaseUrl}/img/consent/option_card_circle_easypay.svg`,
        supportEmail: "customercare@easypay.in",
        loaderImage: `${imageBaseUrl}/img/consent/processing-easypay.png`,
    },
    scspicemoney: {
        name: "Spice Money Limited",
        offers: [
            "Credit upto Rs. 2 lacs",
            "2.5% flat interest per month",
            "Anytime withdrawal",
            "1 day repayment",
            "Money in Bank Account",
        ],
        logo: `${imageBaseUrl}/img/logo/spicemoney-logo.png`,
    },
};
